const resolvers = {
  Query: {
    viewer: (root) => root || {},
  },
  Viewer: {
    id: (root, args, context) => `${context.res.locals.userId || 0}.123abc`,
    isLoggedIn: (root, args, context) =>
      context.res.locals.authenticated === true,
    loginState: (root, args, context) =>
      context.res.locals.loginState || 'LOGGED_OUT',
  },
};

module.exports = resolvers;
